import { FootIconProps } from "../interfaces/PatternView";
import { loadFootCode } from "../services/Foot";
import { getPositionAfterPatterRotation } from "../services/VisServices";


function TableView(props: FootIconProps) {


    const scalingFactor: number = 0.000005;

    function getColor () {
        if(props.danceCouple.joint && props.pos.tangentBodyPart === "Couple Center") {
            return props.coupleColor;
        }else {
            return props.color;
        }
    }


    function getTransform(rightFoot: boolean) {
        let flip = -1;
        if (rightFoot) flip=1;

        return `translate(
                ${props.xScale(getPositionAfterPatterRotation(props.pos, props.patternRotation).x) + flip*props.dms.boundedWidth * 0.005}, 
                ${props.yScale(getPositionAfterPatterRotation(props.pos, props.patternRotation).y) - props.dms.boundedWidth * 0.005})`;
    }

    
    function isVisible(rightFoot: boolean) {
        if (props.danceCouple.joint) {
            if ((rightFoot && "Gentleman Right Foot" === props.pos.tangentBodyPart && props.dancerId===0) ||
                (rightFoot && "Lady Right Foot" === props.pos.tangentBodyPart && props.dancerId===1) ||
                (!rightFoot && "Gentleman Left Foot" === props.pos.tangentBodyPart && props.dancerId===0) ||
                (!rightFoot && "Lady Left Foot" === props.pos.tangentBodyPart && props.dancerId===1) ||
                ("Gentleman Body Center" === props.pos.tangentBodyPart && props.dancerId === 0) ||
                ("Lady Body Center" === props.pos.tangentBodyPart && props.dancerId === 1) ||
                ("Couple Center" === props.pos.tangentBodyPart && rightFoot && props.dancerId===0) || 
                ("Couple Center" === props.pos.tangentBodyPart && !rightFoot && props.dancerId===1) ) {
                    return true;
                }else {
                    return false;
                }
        }else {
            if ((rightFoot && props.pos.tangentBodyPart === "Right Foot") || 
                (!rightFoot && props.pos.tangentBodyPart === "Left Foot") ||
                (props.pos.tangentBodyPart === "Body Center")) {
                return true;
            }else {
                return false;
            }
        }   
    }

    
    return (<g>
        {loadFootCode(getTransform(true), props.dms.boundedWidth*scalingFactor, getColor(), true, isVisible(true))}
        {loadFootCode(getTransform(false), props.dms.boundedWidth*scalingFactor, getColor(), false, isVisible(false))}
    </g>);
}

export default TableView;